import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface Props<T> {
    promise: Promise<T>,
    resolved: (value: T) => React.ReactNode,
    rejected: (error: unknown) => React.ReactNode,
    pending?: () => React.ReactNode,
}

export default function AsyncBlock<T>(props: Props<T>) {
    const [state, setState] = React.useState<
        { status: 'pending' } |
        { status: 'resolved', value: T } |
        { status: 'rejected', error: unknown }
    >({
        status: 'pending',
    });

    React.useEffect(() => {
        props.promise.then(
            (value) => setState({ status: 'resolved', value }),
            (error) => setState({ status: 'rejected', error }),
        );
    }, [props.promise]);

    if (state.status === 'pending') {
        return props.pending ? <>{props.pending()}</> : null;
    } else if (state.status === 'resolved') {
        return <>{props.resolved(state.value)}</>;
    } else {
        return <>props.rejected(state.error)</>;
    }
}

export function AsyncValue<T>(props: { promise: Promise<T>, children: (value: T) => React.ReactNode }) {
    return <AsyncBlock
        promise={props.promise}
        pending={() => <FontAwesomeIcon icon={faSpinner} spin />}
        resolved={props.children}
        rejected={(error) => <span>Error: {String(error)}</span>}
    />;
}